'use client';

import { ReactNode } from 'react';

interface GradientButtonProps {
  children: ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export default function GradientButton({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'md',
  className = '',
  type = 'button',
  disabled = false
}: GradientButtonProps) {
  const baseClasses = 'font-semibold rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg cursor-pointer';
  
  const variantClasses = {
    primary: 'bg-gradient-to-r from-[#4ae6ff] to-[#fc9de3] text-white hover:shadow-xl hover:shadow-[#4ae6ff]/25 border-2 border-[#4ae6ff]',
    secondary: 'bg-white/20 backdrop-blur-md border border-white/30 text-white hover:bg-white/30'
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed hover:scale-100 active:scale-100' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${baseClasses}
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${disabledClasses}
        ${className}
      `}
    >
      {children}
    </button>
  );
}